import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import styles from './SectionSecurity.module.scss';

export default function SectionSecurity() {
  return (
    <section className={styles.section}>
      <div className={styles.banners}>
        <div className={styles.infoContainer}>
          <h1>安全への取り組み</h1>
          <h2>安心してご利用いただけるサービスを目指して</h2>
          <p className={styles.description}>
            ペイディでは、お客様に安心・安全にサービスを
            <br />
            ご利用いただけるよう、セキュリティ対策を強化しています。
          </p>
          <OutboundLink
            href="/security"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            安心への取り組みの詳細を見る
          </OutboundLink>
        </div>
        <img
          className={styles.img}
          src={require('src/images/service-upsell-card.png')}
          alt="QR Code"
        />
      </div>
    </section>
  );
}
